import '../../assets/css/form-validation.css';
import PhoneInputGroup from '../common/PhoneInputGroup';

const BillingAddress = ({ formik, countries, states, cities, showState, showCity, handleBillingCountryChange, handleBillingStateChange, handleBillingCityChange }) => {

    const countryOptions = countries.map(country => ({
        value: country.id,
        label: country.name,
        iso2: country.iso2,
        phone_code: country.phone_code
    }));

    return (
        <div className="checkout-step">
            <div className="step-header">
                <h3>Billing Address</h3>
            </div>
            <div className="step-content">

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control ${formik.touched.billingName && formik.errors.billingName ? 'is-invalid' : ''}`}
                        placeholder="Full Name *"
                        value={formik.values.billingName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="billingName"
                    />
                    {formik.touched.billingName && formik.errors.billingName && (
                        <div className="text-danger">{formik.errors.billingName}</div>
                    )}
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control ${formik.touched.billingAddress && formik.errors.billingAddress ? 'is-invalid' : ''}`}
                        placeholder="Address *"
                        value={formik.values.billingAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="billingAddress"
                    />
                    {formik.touched.billingAddress && formik.errors.billingAddress && (
                        <div className="text-danger">{formik.errors.billingAddress}</div>
                    )}
                </div>

                <div className="row">
                    <div className="col-12">
                        <PhoneInputGroup
                            formik={formik}
                            countryName="billingCountry"
                            phoneName="billingMobileNumber"
                            countries={countries}
                            onCountryChange={handleBillingCountryChange}
                            showLabel={false}
                        />
                    </div>

                    {showState && (
                        <div className="form-group col-md-12">
                            <select
                                className={`form-control ${formik.touched.billingState && formik.errors.billingState ? 'is-invalid' : ''}`}
                                value={formik.values.billingState}
                                onChange={(e) => handleBillingStateChange(e)}
                                onBlur={formik.handleBlur}
                                name="billingState"
                            >
                                <option value="">Select State *</option>
                                {states.map((state) => (
                                    <option key={state.id} value={state.id}>
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                            {formik.touched.billingState && formik.errors.billingState && (
                                <div className="text-danger">{formik.errors.billingState}</div>
                            )}
                        </div>
                    )}
                </div>

                <div className="row">
                    {showCity && (
                        <div className="form-group col-md-6">
                            <select
                                className={`form-control ${formik.touched.billingCity && formik.errors.billingCity ? 'is-invalid' : ''}`}
                                value={formik.values.billingCity}
                                onChange={(e) => handleBillingCityChange(e)}
                                onBlur={formik.handleBlur}
                                name="billingCity"
                            >
                                <option value="">Select City *</option>
                                {cities.map((city) => (
                                    <option key={city.id} value={city.id}>
                                        {city.name}
                                    </option>
                                ))}
                            </select>
                            {formik.touched.billingCity && formik.errors.billingCity && (
                                <div className="text-danger">{formik.errors.billingCity}</div>
                            )}
                        </div>
                    )}

                    <div className="form-group col-md-6">
                        <input
                            type="text"
                            className={`form-control ${formik.touched.billingZip && formik.errors.billingZip ? 'is-invalid' : ''}`}
                            placeholder="ZIP code *"
                            value={formik.values.billingZip}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="billingZip"
                        />
                        {formik.touched.billingZip && formik.errors.billingZip && (
                            <div className="text-danger">{formik.errors.billingZip}</div>
                        )}
                    </div>
                </div>



            </div>
        </div>
    );
};

export default BillingAddress; 